import {
    apiRequest,
    pensiunskCreate,
    masterEmployee
} from "../../../../../services/adapters/kepegawaian/pensiunskService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pensiunskCreate, {
            body: query
        }, true)
    }

     fetchEmployee = async (query) => {
        return await apiRequest("get", masterEmployee, {
            params: query
        }, true)
    }

}

export default CreateRepository